import { motion, useReducedMotion } from "framer-motion";
import { Camera } from "lucide-react";

const frame = {
  hidden: { clipPath: "inset(10% 10% 10% 10%)", scale: 1.12 },
  show: { clipPath: "inset(0% 0% 0% 0%)", scale: 1, transition: { duration: 1.3, ease: [0.22, 1, 0.36, 1] } },
};

export const PhotoSlot = ({ label, caption, ratio = "aspect-[4/5]", className = "", dark = false, testId }) => (
  <div className={className} data-testid={testId}>
    <div className={`flex ${ratio} flex-col items-center justify-center gap-3 border border-dashed p-6 text-center ${dark ? "border-white/25 bg-white/5" : "border-navy/25 bg-mist/60"}`}>
      <Camera className={dark ? "text-gold" : "text-navy/40"} size={32} />
      <p className={`font-display text-sm font-bold ${dark ? "text-paper" : "text-navy"}`}>Photo coming soon</p>
      {label && <p className={`text-xs ${dark ? "text-[#C9D4DF]" : "text-slate"}`}>{label}</p>}
    </div>
    {caption && <p className={`mt-3 text-xs leading-relaxed ${dark ? "text-[#C9D4DF]" : "text-slate"}`}>{caption}</p>}
  </div>
);

export const Photo = ({ image, ratio = "aspect-[4/5]", className = "", testId, eager = false, dark = false, showCaption = false }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : "hidden"}
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      data-testid={testId}
    >
      <figure>
        <div className={`relative ${ratio} overflow-hidden bg-mist`}>
          <motion.img
            variants={frame}
            src={image.src}
            alt={image.alt}
            loading={eager ? "eager" : "lazy"}
            className="absolute inset-0 h-full w-full object-cover"
            style={{ objectPosition: image.position || "center" }}
          />
        </div>
        {showCaption && image.caption && (
          <figcaption className={`mt-3 text-xs leading-relaxed ${dark ? "text-[#C9D4DF]" : "text-slate"}`}>{image.caption}</figcaption>
        )}
      </figure>
    </motion.div>
  );
};
